import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { TextGroup, Card, Text, TextTypes, Icon, Badge, BadgeVariants } from '../index';
import { GiftCard } from '../../types/graphql-global-types';
import CardWrapper, { CardProps } from './card-wrapper';

interface CardMobileProps extends CardProps {
    lineitems: GiftCard[];
    balance: () => HTMLElement;
    cardImage: () => HTMLElement;
    deliveryDate: () => JSX.Element;
}

const CardMobile = ({ card, lineitems, ...props }: CardMobileProps) => {
    const recipient = card.cardrecipientinfo;
    const gcnumber = card.cleansedgcnumber?.slice(-7);
    const carddetid = card.reissuecarddet?.carddetid;

    const [expanded, setExpanded] = useState(true);

    const reissuedBy = () => {
        let index = lineitems.findIndex((x) => x.carddetid === carddetid);
        if (index > -1) {
            return lineitems[index].cleansedgcnumber?.slice(-4);
        }
        return '';
    };

    return (
        <Card className={'order-card ' + (expanded ? 'expanded' : 'collapsed')}>
            {carddetid && (
                <span className="badge">
                    <Badge text={'Reissued by ' + reissuedBy()} variant={BadgeVariants.GRAY} />
                </span>
            )}
            <Row className="card-head" onClick={() => setExpanded(!expanded)}>
                {expanded ? (
                    <Icon name="DownIcon" alt="" size={45} className="down-arrow" />
                ) : (
                    <Icon name="RightIcon" alt="" size={45} className="right-arrow" />
                )}
                <Text type={TextTypes.H4} className="card-name">
                    Card #{gcnumber}
                </Text>
            </Row>
            {expanded && (
                <>
                    <Row>
                        <Col>{props.cardImage()}</Col>
                    </Row>
                    <Row>
                        <TextGroup
                            label="Original Card Value"
                            value={'$' + (card.denomination?.toFixed(2) || '')}
                        />
                    </Row>
                    <Row>
                        <TextGroup label="Current Balance" value={props.balance()} />
                    </Row>
                    <Row>
                        <TextGroup
                            label="Recipient"
                            value={
                                <span className="recipient">
                                    <span>{recipient?.recipientname}</span>
                                    <span>{recipient?.recipientemail}</span>
                                </span>
                            }
                        />
                    </Row>
                    {card.personalmessage && (
                        <Row>
                            <TextGroup label="Message" value={card.personalmessage} />
                        </Row>
                    )}
                    <Row>{props.deliveryDate()}</Row>
                </>
            )}
        </Card>
    );
};

export default CardWrapper(CardMobile);
